var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { I18N } from "aurelia-i18n";
import { autoinject, transient, computedFrom } from "aurelia-framework";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { QueryFilter, DataType } from "../../../../../models/queries/queries.models";
import { Guid } from "../../../../../utilities/guid";
var GamePlayerTicketDraws = /** @class */ (function (_super) {
    __extends(GamePlayerTicketDraws, _super);
    function GamePlayerTicketDraws(notificationService, i18N) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.uri = "TicketLineDraws";
        return _this;
    }
    Object.defineProperty(GamePlayerTicketDraws.prototype, "fixedFilters", {
        get: function () {
            return this.item ? [
                QueryFilter.getQuery("gamePlayerId", this.item.gamePlayerId, "eq", DataType.Number, true, false, Guid.generateGuid(), true)
            ] : [];
        },
        enumerable: false,
        configurable: true
    });
    __decorate([
        computedFrom("item"),
        __metadata("design:type", Array),
        __metadata("design:paramtypes", [])
    ], GamePlayerTicketDraws.prototype, "fixedFilters", null);
    GamePlayerTicketDraws = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N])
    ], GamePlayerTicketDraws);
    return GamePlayerTicketDraws;
}(ChildComponent));
export { GamePlayerTicketDraws };
